import React, { useCallback, useState } from 'react';
import { History } from 'history';
import { useHistory } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useTranslation } from 'react-i18next';
import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import FormHelperText from '@material-ui/core/FormHelperText';
import { Row } from 'components/UI/Row';
import { AuthForm } from 'components/AuthForm';
import { UNAUTHORIZED } from 'http-status-codes';
import { RecoverCodeProps, RecoverCodeSchema } from './RecoverCodeSchema';
import { axiosInstance } from '../axiosInstance';

const RecoverCode = () => {
  const { t } = useTranslation();
  const [backendError, setBackendError] = useState<string>('');
  const history: History = useHistory();
  const { register, handleSubmit, errors, setError } = useForm<RecoverCodeProps>({
    resolver: yupResolver(RecoverCodeSchema)
  });
  const onSubmit = useCallback(
    async ({ token, password, passwordCompare: password_compare }) => {
      try {
        await axiosInstance.post('/users/reset/password', { password, password_compare, token });
        history.replace('/');
      } catch (err) {
        if (!err.response) {
          setBackendError(t('errors.something went wrong'));
          return;
        }
        const { status } = err.response;
        if (status === UNAUTHORIZED) {
          setError('token', { message: '' });
          setError('password', { message: '' });
          setError('passwordCompare', { message: '' });
          setBackendError(t('errors.invalid recovery code or password'));
        } else {
          setBackendError(t('errors.something went wrong'));
        }
      }
    },
    [history, setError]
  );

  return (
    <AuthForm onSubmit={handleSubmit(onSubmit)} noValidate style={{ paddingTop: '30px' }}>
      <Row>
        <span style={{ textAlign: 'center' }}>{t('recover password.instructions')}</span>
      </Row>
      <div style={{ height: '20px' }} />

      <TextField
        helperText={t(get(errors, `token.message`))}
        error={!isEmpty(errors.token)}
        label={t('label.recovery code')}
        inputRef={register}
        name="token"
        style={{ marginBottom: '16px', width: '400px' }}
        variant="outlined"
      />
      <TextField
        autoComplete="new-password"
        helperText={t(get(errors, `password.message`))}
        error={!isEmpty(errors.password)}
        label={t('label.password')}
        inputRef={register}
        name="password"
        type="password"
        style={{ marginBottom: '16px', width: '400px' }}
        variant="outlined"
      />
      <TextField
        autoComplete="new-password"
        helperText={t(get(errors, `passwordCompare.message`))}
        error={!isEmpty(errors.passwordCompare)}
        label={t('label.confirm password')}
        inputRef={register}
        name="passwordCompare"
        type="password"
        style={{ marginBottom: '16px', width: '400px' }}
        variant="outlined"
      />
      {backendError && <FormHelperText style={{ color: '#f44336' }}>{backendError}</FormHelperText>}
      <Row justifyContent="flex-end" width="400px" margin="20px 0 0">
        <Button variant="contained" color="primary" type="submit" style={{ height: '44px', width: '128px' }}>
          {t('label.confirm')}
        </Button>
      </Row>
    </AuthForm>
  );
};

export { RecoverCode };
